import React from "react";
import { Grid, Box } from "@mui/material";
import KenInput from "../../../../../../GlobalComponents/KenInput";
import { IAssignment } from "../../Assignment/index"

interface IGrace {
    data: IAssignment;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    from: string;
}

// Only the "assign" (faculty Assignment wizard) branch remains live — the
// "assesment" (Moodle quiz-settings wizard) branch was dropped along with
// that now-deleted wizard and its Helper/AssessmentHelper.tsx dependency.
const GradeSettings: React.FC<IGrace> = ({ data, handleChange }: IGrace) => {
    return (
        <Box sx={{ p: 2, background: "#F5F7FB", borderRadius: "8px" }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <KenInput
                        type="number"
                        label="Total marks"
                        placeholder="0"
                        name="grade"
                        value={data.grade}
                        onChange={handleChange}
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <KenInput
                        type="number"
                        label="Grade to pass assessment"
                        placeholder="0"
                        name="gradepass"
                        value={data.gradepass}
                        onChange={handleChange}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default GradeSettings;
